<script setup lang="ts">
import  Dialog from 'primevue/dialog';
import { ButtonType, CustomButton } from '@/components/common/';

defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(['onClose', 'onConfirm']);

const closeDialog = () => {
  emits('onClose');
};

const onConfirm = () => {
  emits('onConfirm');
};
</script>

<template>
    <Dialog :visible="visible"
        modal
        :header="title"
        class="dialog"
        style="width: 400px;"
        @update:visible="closeDialog">
        <slot name="bodyContent"></slot>
        <span class="p-text-secondary block mb-8" v-if="description">{{ description }}</span>
        <div class="alert-buttons">
            <div class="alert-buttons-right">
                <CustomButton text="Cancel"
                    @onClick="closeDialog"
                    :type="ButtonType.OUTLINED"/>
                <CustomButton text="Confirm"
                    :margin-left="16"
                    @onClick="onConfirm"
                    :loading="loading"
                    :type="ButtonType.NEGATIVE"/>
            </div>
        </div>
    </Dialog>
</template>

<style scoped lang="scss">
.alert-buttons {
    display: flex;
    justify-content: flex-end;
}
.alert-buttons-right {
    display: flex;
    margin-top: 32px;
}
</style>
